import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-route-header',
  templateUrl: './route-header.component.html',
  styleUrls: ['./route-header.component.css'],
  imports: [CommonModule, ReactiveFormsModule, NgbDropdownModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteHeaderComponent {
  readonly iconClass = input<string>();
  readonly dropdownText = input<string>();
  readonly dropdownOptions = input<string[]>();
  readonly displayFilterInput = input(false);
  readonly filterInputPlaceholder = input<string>();
  readonly displayModalButton = input(false);
  readonly modalButtonText = input('');
  readonly displayDateFilter = input(false);
  readonly dateFilterPlaceholder = input<string>();
  readonly displayCustomButton = input(false);
  readonly customButtonText = input('');
  readonly dropdownChangeEvent = output<string>();
  readonly filterInputChangeEvent = output<string>();
  readonly dateFilterChangeEvent = output<string>();
  readonly openModalClicked = output<boolean>();
  readonly customButtonClicked = output<boolean>();
  readonly exportExcelClicked = output<boolean>();

  filterInput = new UntypedFormControl('');
  dateFilter = new UntypedFormControl('');

  constructor() {
    this.filterInput.valueChanges.subscribe((value: string) => {
      this.filterInputChangeEvent.emit(value);
    });
    this.dateFilter.valueChanges.subscribe((value: string) => {
      this.dateFilterChangeEvent.emit(value);
    });
  }

  dropdownSelected(selection: string): void {
    this.dropdownChangeEvent.emit(selection);
  }

  openModal(): void {
    this.openModalClicked.emit(true);
  }

  onCustomButtonClick(): void {
    this.customButtonClicked.emit(true);
  }

  exportExcel(): void {
    this.exportExcelClicked.emit(true);
  }

  // Native date boundary (SEOMS-460): the datepicker is now a native
  // <input type="date"> (yyyy-MM-dd). Convert to a LOCAL-midnight ISO string on
  // pick — preserving exactly what the retired ISODateAdapter emitted — so the
  // date-filter consumer's `new Date(value)` comparison is unchanged.
  toDateInput(iso: string | null): string {
    if (!iso) {
      return '';
    }
    const d = new Date(iso);
    if (isNaN(d.getTime())) {
      return '';
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  onDatePick(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    if (!value) {
      this.dateFilter.setValue('');
      return;
    }
    const [year, month, day] = value.split('-').map(Number);
    this.dateFilter.setValue(new Date(year, month - 1, day).toISOString());
  }
}
